export interface IMenuItem {
  id?: string;
  src?:any;
  icon?: string;
  label: string;
  to: string;
  newWindow?: boolean;
  subs?: IMenuItem[];
}

const data: IMenuItem[] = [
  {
    icon: 'fa fa-tachometer',
    label: 'Dashboard',
    to: '/dashboard',
    src: 'assets/images/dashboard-icon.png',
  },
  
   {
    icon: 'fa fa-calculator',
    label: 'Cartridges Orders',
    to: '/cartridge',
    src: 'assets/images/Cat.png',
  },
  
  
  
   //!!!!!!!!THE FOLLOWING 2EA PAGES ARE TO BE REMOVED (OR FIXED) LATER...ENABLING THEM NOW FOR LIVE RELEASE IN SUPPORT OF REGISTRATION FORM FIXES 
  {
    icon: 'fa fa-calculator',
    label: 'eTrapps Orders',
    to: '/etrapp',
    src:'assets/images/eTrapp_device_icon.png',
  },
  {
    icon: 'fa fa-calculator',
    label: 'eTrapps Management', // <<---this one is never coming back! "Add Etrapp" makes little sense, QR camera non-functional.
    to: '/etrapp-management',
    src:'assets/images/eTrapp_device_icon.png',
  },
  
  //THE ABOVE 2EA TABS ARE TO BE REMOVED (OR FIXED LATER)...ENABLING THEM NOW FOR LIVE RELEASE IN SUPPORT OF REGISTRATION FORM FIXES 
  
  
  
   {
    icon: 'fa fa-book',
    label: 'Care Center',
    to: '/customer-service',
    src: 'assets/images/customer-service.png',

  },
   
   
   
   
   
   
   
   
  /*!!!!!!!!!!!!COMMENTING OUT ALL OF THE TABS THAT HAVE MY PERSONAL DEVELOPMENT ON THEM (IN SUPPORT OF A LIVE PRODUCTION RELEASE WITH A FIXED REGISTRATION PAGE!!!!
  !!!!!!!!!!THIS IS A TEMPORARY MODIFICATION ONLY
   
  {
	  icon: 'fa fa-tachometer',
	  label: 'NEW Dashboard',
	  to: '/dashboard-new',
	  src: 'assets/images/dashboard-icon.png',
	},
 
	{
        icon: "simple-icon-arrow-right-circle",
        label: 'INCOMING Requests&Alerts',
        to: "/triage/alerts",   
		src: 'assets/images/customer-service.png',
      },
	  {
        icon: "simple-icon-arrow-right-circle",
        label: 'NEW Tickets',
        to: "/triage/tickets",   
		src: 'assets/images/customer-service.png',
      },
   
       
  
  {
    icon: 'fa fa-book',
    label: 'OUTGOING Care Center',
    to: '/customer-service-new',
    src: 'assets/images/customer-service.png',

  },
  
     {
    icon: 'fa fa-calculator',
    label: 'NEW Analytics',
    to: '/diagnostics/analytics',
    src: 'assets/images/Cat.png',
  },
  
 !!!!!!!!!!!!!!!END OF COMMENTING OUT OF MY PERSONAL MENU ITEMS (IN SUPPORT OF REGISTRATION PAGE CLEANUP)!!!!!!!!!!!!!!!!!!!*/
 
 
 
 
 
  
     {
    icon: 'fa fa-tasks',
    label: 'Customers',
    to: '/consumer',
    src: 'assets/images/Layer35.png',

  },
  
  {
    icon: 'fa fa-cog',
    label: 'Technicians',
    to: '/pros',
    src: 'assets/images/Mens-icon.png',

  },
  
 

 

  

  {
    icon: 'fa fa-hospital-o',
    label: 'Rewards',
    to: '/rewards',
    src: 'assets/images/Financial-icon.png',
    subs: [
      {
        icon: "simple-icon-arrow-right-circle",
        label: "Redeem",
        to: "/rewards/redeem",
  
      },
      {
        icon: "simple-icon-arrow-left-circle",
        label: "Invoice",
        to: "/rewards/invoice", 
      }
    ]

  },
  

  {
    icon: 'simple-icon-control-play',
    label: 'Video Tutorials',
    to: '/tutorial',
    src: '',

  },

  
  {
    icon: 'fa fa-cog',
    label: 'Settings',
    to: '/settings',
    src: 'assets/images/Gear-icon.png',

  },
];
export default data;
